/* Popup */

/*import {Swiper, Navigation} from 'swiper';*/
import {loadLibrary} from "./Util";
import {LIB_URL} from '../App';

let $galleryPopup;
let $popupGalleryItems = $('.js-popup-gallery-item');
let popupSwiper;

function closePopup() {
    $('.js-popup._open').removeClass('_open');
}

function renderPopup(itemsArray) {
    loadLibrary(LIB_URL.SWIPER, () => {
        let items = '';

        itemsArray.forEach(function ( item ) {
            items +=`    <div class="swiper-slide"data-image-id="${item.imageId}">
                    <img class="swiper-lazy" data-src="${item.href}" alt="${item.title}" />
                    <div class="popup-swiper-slide-text">${item.title}</div>
                </div>
            `;
        });

        App.B.append(`
            <div class="popup js-popup" data-popup="product-gallery">
                <div class="popup-content">
                    <button class="popup-close-btn js-close-popup-btn"></button>
    
                    <div class="swiper-container popup-swiper-container">
                        <div class="swiper-wrapper popup-swiper-wrapper">
                            ${items}
                        </div>
                    </div>
    
                    <div class="popup-button-prev">
                        <svg class="icon">
                            <use xlink:href="/img/svg-symbols.svg#sym-link-arrow"></use>
                        </svg>
                    </div>
    
                    <div class="popup-button-next">
                        <svg class="icon">
                            <use xlink:href="/img/svg-symbols.svg#sym-link-arrow"></use>
                        </svg>
                    </div>
                </div>
            </div>
        `);

        $galleryPopup = $('[data-popup="product-gallery"]');

        if ($galleryPopup.find('.swiper-slide').length === 1) {
            $galleryPopup.addClass('_no-slider');
        }

        popupSwiper = new Swiper(`.popup-swiper-container`, {
            loop: itemsArray.length > 1,
            simulateTouch: itemsArray.length > 1,
            navigation: {
                prevEl: `.popup-button-prev`,
                nextEl: `.popup-button-next`,
            },
            lazy: {
                loadPrevNext: true,
            },
        });

        App.H.on('click', '.js-close-btn' ,function () {
            $(this).closest('.js-price-popup').removeClass('_open');
            closePopup();
        });

        App.H.on('click', '.js-close-popup-btn', function () {
            closePopup();
        });

        App.H.on('keyup', function (e) {
            // закрытие попап по нажатию Esc
            if (e.keyCode === 27) {
                closePopup();
            }

            // назад
            if ($galleryPopup && $galleryPopup.is('._open') && e.keyCode === 37) {
                popupSwiper.slidePrev();
            }

            // вперед
            if ($galleryPopup && $galleryPopup.is('._open') && e.keyCode === 39) {
                popupSwiper.slideNext();
            }
        });

        App.D.on('mouseup', function (e){
            let $popupContainer = $('.js-popup._open .popup-content');

            if ($popupContainer &&  $popupContainer.length && !$popupContainer.is(e.target) // если клик был не по нашему блоку
                && $popupContainer.has(e.target).length === 0) { // и не по его дочерним элементам, то закрываем попап
                closePopup();
            }
        });
    });
}

if ($popupGalleryItems.length) {
    let items = [];

    $popupGalleryItems.each(function (index, el) {
        let $currItem = $(el);

        $currItem.attr('data-index', index).data('index', index);

        items.push({
            href: $currItem.attr('href') || $currItem.data('image'),
            title: $currItem.attr('title')
        });
    });

    renderPopup(items);

    $popupGalleryItems.on('click', function (e) {
        let currPhotoIndex = $(this).data('index') + 1; // +1 потому что loop

        popupSwiper.slideTo(currPhotoIndex, 0);
        $('.js-popup[data-popup="product-gallery"]').addClass('_open');

        e.preventDefault();
    });
}

// страница новой карточки
if ($('.js-store-product')) {
    let isRendered = false;
    const offers = Array.from($('.js-product-offers option'))
        .map(function (offerDom, i) {
            if (!offerDom.dataset.slider) return [];
            return JSON.parse(offerDom.dataset.slider)
                .map(function (sliderData, i) {
                    return {...sliderData, imageId: offerDom.value + '-' + i};
                });
        })
        .reduce(function (accumulator, product) {
            return accumulator.concat(...product.map(function (item) {
                return {
                    imageId: item.imageId,
                    href: item.imgBig,
                    title: item.title
                };
            }));
        }, []);


    App.D.on('click', '.js-product-card-slide' ,function () {
        const imageId = $(this).data('image-id');

        if (!isRendered) {
            isRendered = true;
            renderPopup(offers);
        }

        popupSwiper.slideTo($(popupSwiper.el).find(`[data-image-id="${imageId}"]:not(.swiper-slide-duplicate)`).index(), 0);
        $('.js-popup[data-popup="product-gallery"]').addClass('_open');
    });
}
